export const SENTRY_VIEWER_SCRIPT_DSN =
  'https://890a7667693a45feafe8156895afe96c@sentry.wixpress.com/32';
export const SENTRY_COMPONENT_SCRIPT_DSN =
  'https://0acfff47cfc74fcdafd0efefc118587a@sentry.wixpress.com/31';
